import { createApp } from 'vue';
import { createPinia } from 'pinia';
import './assets/fonts/sf-pro.css';
import '@fontsource-variable/geist';
import '@fontsource-variable/geist/wght-italic.css';
// Keep Inter bundled for document previews and PDF exports.
import '@fontsource/inter/latin-400.css';
import '@fontsource/inter/latin-ext-400.css';
import '@fontsource/inter/cyrillic-400.css';
import '@fontsource/inter/latin-400-italic.css';
import '@fontsource/inter/latin-ext-400-italic.css';
import '@fontsource/inter/cyrillic-400-italic.css';
import '@fontsource/inter/latin-500.css';
import '@fontsource/inter/latin-ext-500.css';
import '@fontsource/inter/cyrillic-500.css';
import '@fontsource/inter/latin-600.css';
import '@fontsource/inter/latin-ext-600.css';
import '@fontsource/inter/cyrillic-600.css';
import '@fontsource/inter/latin-700.css';
import '@fontsource/inter/latin-ext-700.css';
import '@fontsource/inter/cyrillic-700.css';
import App from './App.vue';
import router from './router';
import './assets/main.css';
import './assets/styles/journal-touch.css';
import sentryPlugin from './plugins/sentry';
import toastPlugin from './plugins/toast';
import loggerPlugin from './plugins/logger';
import tooltipDirective from './directives/tooltip';

const app = createApp(App);
const pinia = createPinia();

app.use(pinia);
app.use(router);
app.use(toastPlugin);
app.use(loggerPlugin, { router });
app.use(sentryPlugin, { router });
app.directive('tooltip', tooltipDirective);

app.mount('#app');
